import { selfAxios } from "../../../../../axios/selfAxios.js";
async function postSplitOrderNew(params) {
  const { data } = await selfAxios.post(`/designapi/kjl/order/spliteOrder`, params);
  return data;
}
export { postSplitOrderNew };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/softwareOneKey/splitOrder/post.js